module.exports = __webpack_public_path__ + "static/img/pin-no-spray-action.dfc6129.svg";